import GuestHeader from './Header';
import AuthHeader from './AuthHeader';

export default {
    Guest: GuestHeader,
    Auth: AuthHeader
}